import {
	AssignStatus,
	InclusionFilterStatus,
	PriorityFilterStatus,
	SelectType,
	SignalFilterStatus,
} from "@/enum/list.enum";

import { SortParams } from "@/types/types";

import { DownloadFilteredRequestParams } from "@/pages/Private/pages/List/schema/list";

import { ASSIGNED_TAB_STATUSES } from "@/pages/Private/pages/List/pages/Unassigned/assignedTabStatuses";

import { FilterUnassignedTable } from "../unassigned-table.types";

interface BuildDownloadPayloadInput {
	page: number;
	limit: number;
	query?: string;
	sorting?: SortParams;
	selectedItems: number[];
	selectType?: SelectType;
	assignStatus?: AssignStatus;
	listId?: number;
	filter?: FilterUnassignedTable;
	inclusionStatus?: InclusionFilterStatus[];
	/** Encoded "STATUS:filterParam" reason sub-filters of the grouped Show dropdown (PREC-3536). */
	exclusionReasons?: string[];
	priorityFilterStatus?: PriorityFilterStatus[];
	signalFilterStatus?: SignalFilterStatus[];
}

const resolveAssignStatus = (assignStatus?: AssignStatus): AssignStatus[] | undefined => {
	if (assignStatus === AssignStatus.ASSIGNED) {
		return ASSIGNED_TAB_STATUSES;
	}

	return assignStatus ? [assignStatus] : undefined;
};

export const getDownloadFilteredPayload = ({
	page,
	limit,
	query,
	sorting,
	selectedItems,
	selectType,
	assignStatus,
	listId,
	filter,
	inclusionStatus,
	exclusionReasons,
	priorityFilterStatus,
	signalFilterStatus,
}: BuildDownloadPayloadInput): DownloadFilteredRequestParams => {
	const isSelectAll = selectType === SelectType.ALL;

	const basePayload: DownloadFilteredRequestParams = {
		searchValue: query,
		sorting,
		assignStatus: resolveAssignStatus(assignStatus),
		listId,
		filter,
		inclusionFilterStatus: inclusionStatus ?? undefined,
		exclusionReasons:
			exclusionReasons && exclusionReasons.length > 0 ? exclusionReasons : undefined,
		priorityFilterStatus: priorityFilterStatus ?? undefined,
		signalFilterStatus: signalFilterStatus ?? undefined,
		selectType,
	};

	if (isSelectAll) {
		return basePayload;
	}

	return {
		...basePayload,
		page,
		limit,
		listPersonIds: selectedItems.length > 0 ? selectedItems : undefined,
	};
};
